import { Property } from 'api/clients/PropertyClient'

export enum PropertyActions {
  REMOVE_PROPERTY = 'REMOVE_PROPERTY',
  UPSERT_PROPERTY = 'UPSERT_PROPERTY',
  UPSERT_PROPERTIES = 'UPSERT_PROPERTIES',
  HIGHLIGHT_PROPERTIES = 'HIGHLIGHT_PROPERTIES',
}

export function removeProperty(propertyId: number) {
  return {
    type: PropertyActions.REMOVE_PROPERTY,
    payload: { propertyId },
  }
}

export function upsertProperty(property: Property) {
  return {
    type: PropertyActions.UPSERT_PROPERTY,
    payload: { property },
  }
}

export function upsertProperties(properties: Property[]) {
  return {
    type: PropertyActions.UPSERT_PROPERTIES,
    payload: { properties },
  }
}

export interface HighlightPropertiesByNameProps {
  [key: string]: boolean
}
export function highlightPropertiesByName(highlightedNames: HighlightPropertiesByNameProps) {
  return {
    type: PropertyActions.HIGHLIGHT_PROPERTIES,
    payload: highlightedNames,
  }
}
